module.exports = __webpack_public_path__ + "img/19_93.d0f52026.png";